<template>
  <div class="row" style="max-width: 100%; overflow-x: hidden;" v-if="userData">
    <div class="col-md-4">
      <div class="row">
        <div class="col">
          <a class="justify-center align-center row">
            <unicon
              name="user-circle"
              width="300"
              height="300"
              :fill="grayCol"
              v-if="userData && !userData.avatar"
            />
            <img
              :src="
                require(`@/assets/avatar/Avatar ${userData.avatar}/Avatar-${userData.avatar}.gif`)
              "
              class="avatar-img transition-all"
              width="300"
              height="300"
              v-if="userData && userData.avatar"
              id="profileAvatar"
            />
          </a>
        </div>
      </div>
      <div class="row">
        <div class="col text-center h3">
          {{ userData.firstname }}
          {{ userData.lastname }}
        </div>
      </div>
      <div class="row">
        <div class="col text-end">
          <button class="button secondary" @click="setAvatar">
            Guardar
          </button>
        </div>
        <div class="col text-initial">
          <button
            class="button primary"
            @click="$emit('changeView', 'profile')"
          >
            Volver
          </button>
        </div>
      </div>
    </div>
    <div class="col-md-8">
      <div class="modal-body d-flex flex-column justify-content-center">
        <h3 class="text-center text-barlow-condensed mx-3 my-2">
          Selecciona tu Avatar
        </h3>

        <!-- Modal de prueba -->

        <div class="cont">
          <div class="but" @click="shiftRight(false)">
            <i class="fas fa-arrow-circle-left fa-2x brand-color-1"></i>
          </div>
          <div class="cards-wrapper">
            <ul class="cards__container">
              <li
                class="avatarBox"
                v-for="(item, i) in new Array(24)"
                :key="i"
                :id="i + 1"
              >
                <div
                  class="avatar-box m-2 d-flex justify-content-center"
                  :id="i"
                >
                  <div :id="i + 1" class="avatar-image">
                    <i class="fas fa-check-circle"></i>
                    <img
                      :src="
                        require(`@/assets/avatar/Avatar ${i + 1}/Avatar-${i +
                          1}.gif`)
                      "
                      class="avatar-img transition-all"
                    />
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="but" @click="shiftLeft(false)">
            <i class="fas fa-arrow-circle-right fa-2x brand-color-1"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

window.$ = require("jquery");

export default {
  name: "AvatarView",
  computed: {
    ...mapState(["teacherData", "userData", "dataUrl"]),
  },
  async mounted() {
    const boxes = document.querySelectorAll(".avatarBox");
    if (boxes.length > 5) {
      for (let i = 5; i < boxes.length; i++) {
        boxes[i].classList.add("avatarBox--hide");
      }
    }

    if (this.userData.avatar > 3) {
      boxes[0].childNodes[0].childNodes[0].classList.add("avatar-active");
      for (let i = 0; i < this.userData.avatar - 3; i++) {
        await this.shiftLeft(true);
      }
    } else {
      switch (this.userData.avatar) {
        case 3:
          boxes[2].childNodes[0].childNodes[0].classList.add("avatar-active");
          break;
        case 2:
          this.shiftRight(true);
          break;
        case 1:
          await this.shiftRight(true);
          await this.shiftRight(true);
          break;
        default:
          boxes[2].childNodes[0].childNodes[0].classList.add("avatar-active");
          break;
      }
    }
  },
  data() {
    let { secCol, grayCol } = this.$store.getters;

    return {
      secCol,
      grayCol,
      selectedAvatar: null,
      // selectedAvatarSrc: `@/assets/avatar/Avatar ${this.userData.avatar}/Avatar-${this.userData.avatar}.gif`,
    };
  },
  methods: {
    shiftLeft(init) {
      return new Promise(resolve => {
        const boxes = document.querySelectorAll(".avatarBox");
        const tmpNode = boxes[0];
        boxes[0].className = "avatarBox move-out-from-left";

        setTimeout(
          function() {
            window.$(".avatar-active").removeClass("avatar-active");
            if (boxes.length > 5) {
              tmpNode.classList.add("avatarBox--hide");
              boxes[5].className = "avatarBox move-to-position5-from-left";
            }
            boxes[1].className = "avatarBox move-to-position1-from-left";
            boxes[2].className = "avatarBox move-to-position2-from-left";
            boxes[3].className = "avatarBox move-to-position3-from-left";

            boxes[3].childNodes[0].childNodes[0].className += " avatar-active";
            window
              .$(".avatar-active")
              .children("img")
              .attr(
                "src",
                window
                  .$(".avatar-active")
                  .children("img")
                  .attr("src")
              );

            boxes[4].className = "avatarBox move-to-position4-from-left";
            boxes[0].remove();

            document.querySelector(".cards__container").appendChild(tmpNode);
            resolve();
          },
          init ? 0 : 200
        );
      });
    },
    shiftRight(init) {
      return new Promise(resolve => {
        window.$(".avatar-active").removeClass("avatar-active");
        const boxes = document.querySelectorAll(".avatarBox");
        boxes[4].className = "avatarBox move-out-from-right";
        setTimeout(
          function() {
            const noOfCards = boxes.length;
            if (noOfCards > 4) {
              boxes[4].className = "avatarBox avatarBox--hide";
            }

            const tmpNode = boxes[noOfCards - 1];
            tmpNode.classList.remove("avatarBox--hide");
            boxes[noOfCards - 1].remove();
            let parentObj = document.querySelector(".cards__container");
            parentObj.insertBefore(tmpNode, parentObj.firstChild);
            tmpNode.className = "avatarBox move-to-position1-from-right";
            boxes[0].className = "avatarBox move-to-position2-from-right";
            boxes[1].className = "avatarBox move-to-position3-from-right";

            boxes[1].childNodes[0].childNodes[0].className += " avatar-active";
            window
              .$(".avatar-active")
              .children("img")
              .attr(
                "src",
                window
                  .$(".avatar-active")
                  .children("img")
                  .attr("src")
              );

            boxes[2].className = "avatarBox move-to-position4-from-right";
            boxes[3].className = "avatarBox move-to-position5-from-right";
            resolve();
          },
          init ? 0 : 200
        );
      });
    },
    ...mapMutations(["setUserData"]),
    setUserAvatar(avatar) {
      if (avatar) {
        let userData = this.userData;
        userData.avatar = avatar;
        this.setUserData(userData);
      }
    },
    async setAvatar() {
      this.selectedAvatar =
        Number.parseInt(window.$(".avatar-active")[0].id) - 1;
      if (!this.selectedAvatar && this.selectedAvatar !== 0) {
        this.$notify({
          title: ["Seleccione avatar"],
          type: "danger",
        });
        return;
      }

      let apiUrl = `${this.dataUrl}/userProfile/updateUserAvatar?userId=${
        this.teacherData.id
      }&avatar=${this.selectedAvatar + 1}`;

      let loader = this.$loading.show();

      try {
        let { data } = await this.axios.put(apiUrl);

        if (data.status.name.toLocaleLowerCase() == "ok") {
          this.$notify({
            title: ["Cambio exitoso"],
            type: "success",
          });
          this.setUserAvatar(this.selectedAvatar + 1);
        } else {
          this.$notify({
            title: ["Ocurrió un error", data.content],
            type: "danger",
          });
        }
      } catch {
        this.$notify({
          title: ["Ocurrió un error"],
          type: "danger",
        });
      } finally {
        loader.hide();
      }
    },
  },
};
</script>

<style lang="scss">
.avatar-active {
  border: #ffb511 0.5vh;
  border-style: solid;
  background-color: #fff7db;
}

.avatar-image i {
  display: none;
}

.avatar-active i {
  display: block;
  position: absolute;
  top: 1vh;
  right: 1vh;
  font-size: 32px;
  color: #ffb511;
  background: white;
  border-radius: 500px;
}

.avatar-active .avatar-img,
.category-active .avatar-img {
  padding: 0;
}

.avatar-box,
.avatar-image {
  border-radius: 500px;
}

.avatar-img {
  padding: 10px;
}

.avatar-img:hover {
  padding: 0;
}

.cont {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.but {
  /* margin-left: 0 3%; */
  width: 2rem;
  cursor: pointer;
  z-index: 30;
}

.but--inactive {
  opacity: 0.2;
}

.but img {
  width: 60%;
}

.cards-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 76%;
}

.cards__container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 15rem;
  width: 160%;
  margin: 0;
}

.avatarBox {
  width: 12rem;
  box-shadow: 0px 0px 2rem 0px #888888;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 3;
  border-radius: 500px;
}

.avatarBox:nth-child(2n) {
  transform: scale(0.85);
  z-index: 2;
}

.avatarBox:nth-child(2) {
  left: 5%;
}

.avatarBox:nth-child(4) {
  left: -5%;
}

.avatarBox:nth-child(4n + 1) {
  transform: scale(0.75);
  z-index: 1;
}

.avatarBox:nth-child(1) {
  left: 15%;
}

.avatarBox:nth-child(5) {
  left: -15%;
}

.card__text-content {
  text-align: center;
  width: 75%;
}

.card__title {
  padding: 1rem;
}

.avatarBox--hide {
  display: none;
}

.move-out-from-left {
  animation: moveOutLeft 0.2s ease-in-out;
}

.move-out-from-right {
  animation: moveOutRight 0.2s ease-in-out;
}

.move-to-position5-from-left {
  animation: moveToP5Left 0.2s ease-in-out;
}

.move-to-position4-from-left {
  animation: moveToP4Left 0.2s ease-in-out;
}

.move-to-position3-from-left {
  animation: moveToP3Left 0.2s ease-in-out;
}

.move-to-position2-from-left {
  animation: moveToP2Left 0.2s ease-in-out;
}

.move-to-position1-from-left {
  animation: moveToP1Left 0.2s ease-in-out;
}

.move-to-position5-from-right {
  animation: moveToP5Right 0.2s ease-in-out;
}

.move-to-position4-from-right {
  animation: moveToP4Right 0.2s ease-in-out;
}

.move-to-position3-from-right {
  animation: moveToP3Right 0.2s ease-in-out;
}

.move-to-position2-from-right {
  animation: moveToP2Right 0.2s ease-in-out;
}

.move-to-position1-from-right {
  animation: moveToP1Right 0.2s ease-in-out;
}

@keyframes moveOutLeft {
  0% {
    transform: scale(0.75) translateX(0%);
    opacity: 1;
  }
  50% {
    transform: scale(0.5) translateX(-150%);
    opacity: 0.5;
  }
  100% {
    transform: scale(0.25) translateX(0%);
    opacity: 0;
  }
}

@keyframes moveOutRight {
  0% {
    transform: scale(0.75) translateX(0%);
    opacity: 1;
  }
  50% {
    transform: scale(0.5) translateX(150%);
    opacity: 0.5;
  }
  100% {
    transform: scale(0.25) translateX(0%);
    opacity: 0;
  }
}

@keyframes moveToP5Left {
  from {
    transform: scale(0.75) translateX(100%);
  }
  to {
    transform: scale(0.75) translateX(0);
  }
}

@keyframes moveToP4Left {
  from {
    transform: scale(0.75) translateX(100%);
  }
  to {
    transform: scale(0.85) translateX(0);
  }
}

@keyframes moveToP3Left {
  from {
    transform: scale(0.85) translateX(100%);
  }
  to {
    transform: scale(1) translateX(0);
  }
}

@keyframes moveToP2Left {
  from {
    transform: scale(1) translateX(100%);
  }
  to {
    transform: scale(0.85) translateX(0);
  }
}

@keyframes moveToP1Left {
  from {
    transform: scale(0.85) translateX(100%);
  }
  to {
    transform: scale(0.75) translateX(0);
  }
}

@keyframes moveToP1Right {
  from {
    transform: scale(0.75) translateX(-100%);
  }
  to {
    transform: scale(0.75) translateX(0);
  }
}

@keyframes moveToP2Right {
  from {
    transform: scale(0.75) translateX(-100%);
  }
  to {
    transform: scale(0.85) translateX(0);
  }
}

@keyframes moveToP3Right {
  from {
    transform: scale(0.85) translateX(-100%);
  }
  to {
    transform: scale(1) translateX(0);
  }
}

@keyframes moveToP4Right {
  from {
    transform: scale(1) translateX(-100%);
  }
  to {
    transform: scale(0.85) translateX(0);
  }
}

@keyframes moveToP5Right {
  from {
    transform: scale(0.85) translateX(-100%);
  }
  to {
    transform: scale(0.75) translateX(0);
  }
}
</style>
